<div class="blue full body">
    <app-navbar></app-navbar>



<div class="main">
    <div class="white">
        <h1>EUREKA! GCC 2022-23</h1>
        <h1>COMING SOON</h1>
    </div>


</div>

<div>
    <app-footer></app-footer>
</div>
</div>